import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import cmfGuide_en from "./locales/en/cmfGuide.json";
import common_en from "./locales/en/common.json";
import footer_en from "./locales/en/footer.json";
import header_en from "./locales/en/header.json";
import helpCenter_en from "./locales/en/helpCenter.json";
// import enTranslations from './locales/en.json';
import landingPage_en from "./locales/en/landingPage.json";
import roleSelection_en from "./locales/en/roleSelection.json";
import searchPage_en from "./locales/en/searchPage.json";
import userProfile_en from "./locales/en/userProfile.json";
import userSetting_en from "./locales/en/userSetting.json";
import whatsNew_en from "./locales/en/whatsNew.json";

// import deTranslations from './locales/de.json';
// import landingPage_de from './locales/de/landingPage.json';
// import header_de from './locales/de/header.json';
// import footer_de from './locales/de/footer.json';
// import helpCenter_de from './locales/de/helpCenter.json';
// import searchPage_de from './locales/de/searchPage.json';
// import userSetting_de from './locales/de/userSetting.json';
// import userProfile_de from './locales/de/userProfile.json';
// import common_de from './locales/de/common.json';

// import zhTranslations from './locales/zh.json';
// import landingPage_zh from './locales/zh/landingPage.json';
// import header_zh from './locales/zh/header.json';
// import footer_zh from './locales/zh/footer.json';
// import helpCenter_zh from './locales/zh/helpCenter.json';
// import searchPage_zh from './locales/zh/searchPage.json';
// import userSetting_zh from './locales/zh/userSetting.json';
// import userProfile_zh from './locales/zh/userProfile.json';
// import common_zh from './locales/zh/common.json';

const enTranslations = {
  ...landingPage_en,
  ...header_en,
  ...footer_en,
  ...helpCenter_en,
  ...searchPage_en,
  ...userSetting_en,
  ...userProfile_en,
  ...roleSelection_en,
  ...cmfGuide_en,
  ...whatsNew_en,
  ...common_en,
};

// const deTranslations = {...landingPage_de, ...header_de, ...footer_de, ...helpCenter_de,
//                 ...searchPage_de, ...userSetting_de, ...userProfile_de, ...common_de}

// const zhTranslations = {...landingPage_zh, ...header_zh, ...footer_zh, ...helpCenter_zh,
//                 ...searchPage_zh, ...userSetting_zh, ...userProfile_zh, ...common_zh}

i18n
  .use(initReactI18next) // Passes i18n instance to react-i18next
  .init({
    resources: {
      en: { translation: enTranslations },
    },
    lng: "en", // Default language
    fallbackLng: "en", // Fallback language
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
